import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    ElectricmeterService,
    ElectricmeterPopupService,
    ElectricmeterComponent,
    ElectricmeterDetailComponent,
    ElectricmeterDialogComponent,
    ElectricmeterPopupComponent,
    ElectricmeterDeletePopupComponent,
    ElectricmeterDeleteDialogComponent,
    electricmeterRoute,
    electricmeterPopupRoute,
    ElectricmeterResolvePagingParams,
} from './';

const ENTITY_STATES = [
    ...electricmeterRoute,
    ...electricmeterPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ElectricmeterComponent,
        ElectricmeterDetailComponent,
        ElectricmeterDialogComponent,
        ElectricmeterDeleteDialogComponent,
        ElectricmeterPopupComponent,
        ElectricmeterDeletePopupComponent,
    ],
    entryComponents: [
        ElectricmeterComponent,
        ElectricmeterDialogComponent,
        ElectricmeterPopupComponent,
        ElectricmeterDeleteDialogComponent,
        ElectricmeterDeletePopupComponent,
    ],
    providers: [
        ElectricmeterService,
        ElectricmeterPopupService,
        ElectricmeterResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerElectricmeterModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/electricmeter/electricmeter.module.ts